import { Box } from '@mui/material';
import { useEffect } from 'react';
import {
  Outlet,
  useSearchParams
} from 'react-router-dom';



export const ExternalLayout = () => {
  const [
    searchParams,
    setSearchParams
  ] = useSearchParams();

  useEffect(() => {
    if (searchParams.has('continue')) {
      setSearchParams((p) => {
        p.delete('continue');
        return p;
      });
    }
  }, [
    searchParams,
    setSearchParams
  ]);

  return (
    <Box sx={{
      width: '100vw',
      height: '100vh',
      backgroundColor: 'white',
      // This is to cover the fact that the root layout sets 1.5rem padding.
      margin: '-1.5rem'
    }}
    >
      <Outlet />
    </Box>
  );
};
